module.exports = __webpack_public_path__ + "assets/img/VentureCrowd-Article-w540.62796a9a.webp";